import React, { PropsWithChildren } from "react";
import classes from "./styles.module.scss";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import resolvePath from "Utils/resolvePath";
import { WorkspaceReservationMethod } from "Services/API/API";
import { Button } from "Components/ReactstrapSlim";

function getColor(fieldValue, value) {
   return fieldValue == value
      ? "check--checked"
      : "check--unchecked"
}

interface ReservationMethodSelectorProps<T extends FieldValues> {
   control: Control<T>,
   name: FieldPath<T>,
   disabled?: boolean
}

export const ReservationMethodSelector = <T extends FieldValues,>({ control, name, disabled, ...rest }: PropsWithChildren<ReservationMethodSelectorProps<T>>) => {
   return <Controller control={control} name={name} render={({ field, formState: { errors } }) => {
      const error = resolvePath(errors, name);
      return <div className={classes.container}>
         <input type="hidden" value={field.value ?? -1} />
         {error ? <div className={classes.error}>{error.message}</div> : null}
         <Button className={classes.button} disabled={disabled} onClick={ev => { ev.preventDefault(); field.onChange(WorkspaceReservationMethod.SpecificTimePeriod); }} color={getColor(field.value, WorkspaceReservationMethod.SpecificTimePeriod)}>Hourly</Button>
         <Button className={classes.button} disabled={disabled} onClick={ev => { ev.preventDefault(); field.onChange(WorkspaceReservationMethod.DayPass); }} color={getColor(field.value, WorkspaceReservationMethod.DayPass)}>Daily</Button>
         <Button className={classes.button} disabled={disabled} onClick={ev => { ev.preventDefault(); field.onChange(WorkspaceReservationMethod.Period); }} color={getColor(field.value, WorkspaceReservationMethod.Period)}>Monthly</Button>
      </div>
   }}
   />
}

export default ReservationMethodSelector; 